import { DodonaElement } from "@/components/meta/dodona_element";
import { showInlineFile, showRealFile } from "@/file_viewer";
import { activityFileUrl } from "@/feedback/file_url";
import type { FileEntry } from "@/types/FeedbackResult";
import { html, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";

/**
 * Renders an inline link to a file in the feedback table.
 *
 * @element d-feedback-file-link
 *
 * @property {FileEntry["location"]} location Where the file is.
 * @property {string} name The name of the file to render.
 * @property {string} content Url or inline contents, depending on the location.
 * @property {string} activityPath The path to the activity.
 * @property {string} accessToken The access token to use for the file viewer.
 */
@customElement("d-feedback-file-link")
export class FeedbackFileLink extends DodonaElement {
    @property({ type: String }) location!: FileEntry["location"];
    @property({ type: String }) name!: string;
    @property({ type: String }) content!: string;

    @property({ type: String }) activityPath: string = "";
    @property({ type: String }) accessToken: string | null = null;

    private onClickLink(e: Event): void {
        e.preventDefault();

        if (this.location === "inline") {
            showInlineFile(this.name, this.content);
        } else if (this.location === "href") {
            showRealFile(this.name, this.url);
        }
    }

    private get url(): string {
        return activityFileUrl(this.content, this.activityPath, this.accessToken);
    }

    render(): TemplateResult {
        // Add a real link if the entry has a location.
        const path = this.location === "href" ? this.url : "#";
        return html`<a href="${path}" @click=${this.onClickLink}>${this.name}</a>`;
    }
}
